import React, { FC, useCallback } from 'react';
import { SessionContainer } from '@legacyApp/client/components/provablyFair/session';
import {
	SettingsLayout,
	SettingsLayoutSection,
} from '../../components/settingsLayout/settingsLayout';
import { createNamespaceTrans } from '../../modules/translation/translate';
import { ImplementationContainer } from '../../components/provablyFair/implementation';
import { StyledMainDashboardV2 } from '../../modules/style/components/MainDashboard.styled';
import { TransNamespace } from '../../modules/translation/TransNamespace';
import { ProvableFairOverview } from '../../components/provablyFair/overview';
import { VerificationContainer } from '../../components/provablyFair/verification/verification.container';
import { StyledProvablyFairGlobal } from './ProvablyFair.global.styled';

export const transProvablyFair = createNamespaceTrans(
	TransNamespace.PROVABLY_FAIR_PAGE,
);

enum SECTIONS {
	OVERVIEW = 'overview',
	SESSION = 'session',
	VERIFICATION = 'verification',
	IMPLEMENTATION = 'implementation',
}

const SECTIONS_CONFIG: SettingsLayoutSection[] = [
	{
		id: SECTIONS.OVERVIEW,
		name: () => 'Overview',
	},
	{
		id: SECTIONS.SESSION,
		name: () => 'Session',
		isLogged: true,
	},
	{
		id: SECTIONS.VERIFICATION,
		name: () => 'Verification',
	},
	{
		id: SECTIONS.IMPLEMENTATION,
		name: () => 'Implementation',
	},
];

const SECTIONS_CONTENT = {
	[SECTIONS.OVERVIEW]: <ProvableFairOverview />,
	[SECTIONS.SESSION]: <SessionContainer />,
	[SECTIONS.VERIFICATION]: <VerificationContainer />,
	[SECTIONS.IMPLEMENTATION]: <ImplementationContainer />,
};

export const ProvablyFairPage: FC = () => {
	const getSectionContent = useCallback((id) => {
		return SECTIONS_CONTENT[id] || null;
	}, []);

	return (
		<StyledMainDashboardV2>
			<StyledProvablyFairGlobal />
			<h1 className="page-title">
				{transProvablyFair({ label: 'Provably fair' })}
			</h1>
			<SettingsLayout
				getSectionContent={getSectionContent}
				sections={SECTIONS_CONFIG}
				defaultTab={SECTIONS.OVERVIEW}
			/>
		</StyledMainDashboardV2>
	);
};
